import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { cloneDeep } from 'lodash';
import { map } from 'rxjs';
import {
	CondoCorporationModalComponent,
	DispatchTypes,
} from 'src/app/private/sale/property/condo-corp/condo-corporation-modal/condo-corporation-modal.component';
import {
	DeleteConfirmationModalComponent,
	DeleteModalTypes,
} from 'src/app/private/sale/property/condo-corp/delete-confirmation-modal/delete-confirmation-modal.component';
import { addressString } from '@core/util/address';
import {
	DropdownOption,
	DropdownResult,
} from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { Company } from '@models/company';
import { CondoManagement } from '@models/matter';
import { AI_GENERATED_ICON } from '@core/util/icon';

@Component({
	selector: 'app-sale-condo-mgmt-search-card',
	templateUrl: './condo-mgmt-search-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CondoMgmtSearchCardComponent {
	public AI_GENERATED_ICON = AI_GENERATED_ICON;
	public management$ = inject(Store)
		.select(SelectedMatter.condoCorporation)
		.pipe(map((corporationObject) => corporationObject?.management));

	public condoCorp = inject(Store).selectSnapshot(
		SelectedMatter.condoCorporation,
	)?.condoCorp;

	public condoManagementAddressString$ = this.management$.pipe(
		map((management) => addressString(management?.address)),
	);

	public showAiIcon$ = inject(Store)
		.select(SelectedMatter.getFieldMappings)
		.pipe(
			map((fieldMappings) => !!fieldMappings?.condoCorporation?.management),
		);
	public label = 'Condo Management Company';

	constructor(
		private matDialog: MatDialog,
		private matterDispatch: MatterDispatch,
	) {}

	onCreateCondoManagement(name: string) {
		this.matDialog.open(CondoCorporationModalComponent, {
			data: {
				name,
				dispatchType: DispatchTypes.CONDO_MANAGEMENT,
				condoCorpId: this.condoCorp.id,
				condoCorporation: cloneDeep(this.condoCorp),
			},
		});
	}

	condoManagementDropdownEvent(
		event: DropdownResult<DropdownOption<string>>,
		management: Company,
	) {
		switch (event.result.name) {
			case 'Edit':
				this.matDialog.open(CondoCorporationModalComponent, {
					data: {
						dispatchType: DispatchTypes.CONDO_MANAGEMENT,
						company: management,
					},
				});
				break;
			case 'Remove':
				this.matDialog.open(DeleteConfirmationModalComponent, {
					data: {
						deleteModalType: DeleteModalTypes.MANAGEMENT_COMPANY,
					},
				});
				break;
		}
	}

	onSelectCondoCorporationManagement(
		selectedCondoCorpManagement: DropdownResult<CondoManagement>,
	) {
		this.matterDispatch.SetCondoCorporationManagement(
			selectedCondoCorpManagement.result.id,
			this.condoCorp.id,
		);
	}
}
